import Link from 'next/link'
import styles from '@/styles/watch-detail.module.scss'
import marked from 'marked'
import { useState, useEffect , useCallback } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Thumbs, Navigation } from 'swiper'
import Image from '@/components/general/Image/Image'
import { getProductById } from '@/service/product-list.api'
import { addCommas } from '@/utils/formatter'
import useMemberBadge from '@/helpers/memberBadge'
import GalleryModal from '@/components/general/modal/gallery/GalleryModal'
import { format } from 'date-fns'

marked.setOptions({
  gfm: true,
  tables: true,
  breaks: false,
  pedantic: false,
  smartLists: true,
  smartypants: false
})

export async function getServerSideProps(context) {
  const { id } = context.params
  try {
    const response = await getProductById(id)
    if (response.data.userProduct.isDeleted) {
      throw new Error()
    }
    return {
      props: {
        data: response.data.userProduct
      }
    }
  } catch (e) {
    return {
      redirect: {
        destination: '/search-market',
        permanent: false
      }
    }
  }
}

export default function WatchDetail({ data }) {
  useEffect(() => {
    let recentlyViewed = localStorage.getItem('recently_viewed')
      if (!recentlyViewed) {
        recentlyViewed = []
      } else {
        recentlyViewed = JSON.parse(recentlyViewed)
      }
      recentlyViewed = recentlyViewed.filter(item => item.id !== data.id)
      recentlyViewed.unshift({ id: data.id, type: 'watch' })
      localStorage.setItem('recently_viewed', JSON.stringify(recentlyViewed.slice(0, 4)))
  }, [data.id])
  const [swiper, setSwiper] = useState(null)
  const [swiperThumb, setSwiperThumb] = useState(null)
  const [showModalGallery, setShowModalGallery] = useState(false)
  const sellerData = data?.users_permissions_user || {}
  const badgeData = useMemberBadge(data?.users_permissions_user)

  const handleGallerySlideChange = useCallback((swiperInstance) => {
    swiper?.slideTo(swiperInstance.realIndex, 200)
  }, [swiper])

  const badge = (
    <span className={styles.wrapBadge}>
      <div
        className={styles.badge}
        {
            ...(
              badgeData.color && { style: { '--badge-color': badgeData.color } }
            )
          }
      >
        {badgeData.text}
      </div>
    </span>
  )
  return (
    <div className={styles.watchDetail}>
      {
        data.images && (
          <GalleryModal isOpen={showModalGallery} onClose={() => setShowModalGallery(false)}>
            <Swiper
              style={{ height: '100%' }}
              modules={[Thumbs,Navigation]}
              navigation
              watchSlidesProgress
              onSwiper={(instance) => {
                instance.slideTo(swiper?.realIndex, 0)
              }}
              onSlideChange={handleGallerySlideChange}
            >
              {
                data.images.map((img) => (
                  <SwiperSlide key={img.id}>
                    {/* <div className={styles.gallerySlide}> */}
                      <Image stylingClass={styles.fullHeight} contain src={img.url} width="100%" height="100%" layout="responsive" />
                    {/* </div> */}
                  </SwiperSlide>
                ))
              }
            </Swiper>
          </GalleryModal>
        )
      }
      <div className={`flex wrap max-width ${styles.border}`}>
        <div className={styles.gallery}>
          {
            data.images
            && (
            <Swiper
              modules={[Thumbs, Navigation]}
              navigation={true}
              // updateOnImagesReady
              preloadImages
              thumbs={{
                swiper:swiperThumb
              }}
              onSwiper={(instance) => {
                setSwiper(instance)
                window.testswiper = instance
              }}
            >
              {
                data.images.map((img) => (
                  <SwiperSlide key={img.id} onClick={() => setShowModalGallery(true)}>
                    <Image contain src={img.url} width="940" height="670" layout="responsive" />
                  </SwiperSlide>
                ))
              }
            </Swiper>
            )
          }
          <div className={styles.galleryThumbnail}>
          {
            data.images
            && (
            <Swiper
              modules={[Thumbs]}
              slidesPerView={4}
              spaceBetween={10}
              // updateOnImagesReady
              preloadImages
              onSwiper={setSwiperThumb}
              freeMode={true}
              watchSlidesProgress
            >
              {
                data.images.map((img) => (
                  <SwiperSlide key={img.id}>
                    <Image cover src={img.url} width="100" height="100" layout="responsive" />
                  </SwiperSlide>
                ))
              }
            </Swiper>
            )
          }
          </div>
        </div>
        <div className={styles.mainDetail}>
          <div className={styles.head}>
            <div className={styles.productName}>{data.name}</div>
            {data.price && <div className={styles.price}>{`฿ ${addCommas(data.price?.toString() || '0')}`}</div>}
            {format(new Date(data.updatedAt), 'dd/MM/yyyy HH:mm')}
          </div>
          {/* <div className={styles.verifySection}>
            {sellerData.isVerified
             && (
             <>
               <span className={styles.verifiedIcon}>
                 <img src="/icon/verify.png" />
               </span>
               <div className={styles.title}>Expert Watch Buyer Protect</div>
             </>
             )}
            <div className={styles.desc}>{sellerData.isVerified ? 'Verified Dealer' : 'Normal Dealer'}</div>
            {sellerData.isVerified && <div className={styles.desc}>Expert Watch Buyer Protect</div>}
          </div> */}
          <div className={styles.detailRow}>
            <div className={styles.key}>AVAILABILITY</div>
            <div className={styles.value}>
              <div className={`${styles.status} ${data.isSoldOut && styles.soldOut}`} />
              {data.isSoldOut ? 'SOLD OUT' : 'AVAILABLE NOW'}
            </div>
          </div>
          {
            !data.isPostByAdmin
            && (
              <div className={styles.detailRow}>
                <div className={styles.warning}>
                  <span>**</span> Expert เป็นเพียงผู้ให้บริการพื้นที่สำหรับซื้อขายแลกเปลี่ยนนาฬิกาเท่านั้น ไม่มีส่วนเกี่ยวข้องกับผู้ขายแต่ประการใด กรุณารอบคอบในการแลกเปลี่ยนและซื้อขาย
                  <br />หากไม่มั่นใจสามารถนำนาฬิกาไป <a href="https://www.expert-watch.com/authenticate/" rel="noreferrer" target="_blank">ตรวจสอบได้ที่ Expert Watch ทั้ง 5 สาขา</a> <span>**</span>
                </div>
              </div>
            )
          }
          <div className={`${styles.detailRow} ${styles.wrap}`}>
            <div className={styles.key}>SELLER</div>
            <div className={styles.sellerDetail}>
              <div className={styles.profile}>
                <Link href={`/dealers/${sellerData.id}`}>
                  <a href={`/dealers/${sellerData.id}`}>
                    <div className={styles.imgWrap}>
                      <img className={styles.avatar} src={sellerData.profileImage?.url || '/icon/default-avatar.png'} />
                    </div>
                  </a>
                </Link>
              </div>
              <div className={styles.row}>
                <Link href={`/dealers/${sellerData.id}`}>
                  <a href={`/dealers/${sellerData.id}`} className={styles.name}>{sellerData.username}</a>
                </Link>
                {badge}
                <div className={styles.contactList}>
                  {
                    sellerData.phone
                  && (
                  <div className={styles.contact}>
                    <span className={styles.key}>Phone:</span>
                    <a href={`tel:${sellerData.phone}`}>
                      {sellerData.phone}
                    </a>
                  </div>
                  )
                  }
                  <div className={styles.contact}>
                    <span className={styles.key}>Line ID:</span>
                    {/* <a href={`mailto:${sellerData.email}`}>
                      {sellerData.email}
                    </a> */}
                    {
                      sellerData.lineId ? (
                        <a href={`https://line.me/ti/p/~${sellerData.lineId}`}>
                          {sellerData.lineId}
                        </a>
                      )
                      : '-'
                    }
                  </div>
                  {
                    sellerData.facebook
                    && (
                    <div className={styles.contact}>
                      <span className={styles.key}>Facebook:</span>
                      {sellerData.facebook}
                    </div>
                    )
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className={styles.bar}>
        <div className={`${styles.barContent} max-width`}>
          <div className={styles.item}>DETAIL</div>
        </div>
      </div> */}
      <section className={styles.detail}>
        <div className={styles.heading}>
          DETAIL
        </div>
        <div className={`${styles.detailWrap} max-width`}>
          <div className={styles.col}>
            <span className={styles.title}>Basic Info</span>
            <div className={styles.detailRow}>
              <div className={`${styles.key} font-semibold`}>Brand</div>
              <div className={styles.value}>{data.brand?.brandName}</div>
            </div>
            <div className={styles.detailRow}>
              <div className={`${styles.key} font-semibold`}>Model (Ref.)</div>
              <div className={styles.value}>{data.model}</div>
            </div>
            {/* <div className={styles.detailRow}>
              <div className={`${styles.key} font-semibold`}>Case Material</div>
              <div className={styles.value}>case</div>
            </div> */}
            <div className={styles.detailRow}>
              <div className={`${styles.key} font-semibold`}>Original Card / Paper</div>
              <div className={styles.value}>{data.warrantyCard ? 'YES' : 'NO'}</div>
            </div>
            <div className={styles.detailRow}>
              <div className={`${styles.key} font-semibold`}>Year of Warranty Card</div>
              <div className={styles.value}>{data.yearOfWarrantyCard || '-'}</div>
            </div>
            <div className={styles.detailRow}>
              <div className={`${styles.key} font-semibold`}>Original Box</div>
              <div className={styles.value}>{data.originalBox ? 'YES' : 'NO'}</div>
            </div>
          </div>
          <div className={styles.col}>
            <span className={styles.title}>Description</span>
            {data.description && <div className={styles.description} dangerouslySetInnerHTML={{ __html: marked(data.description || '') }} />}
          </div>
        </div>
      </section>
      {/* <section className={styles.detail}>
        <div className={styles.heading}>SELLER</div>
        {sellerData.isVerified}

        {sellerData.isVerified}
      </section> */}
    </div>
  )
}
